import { memo, useEffect, useState } from "react";
import { BzModal, BzModalBody, BzModalHeader } from '../../components';
import { Row, Col, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { handleModal } from "../../redux/actions/modals"

const DisclaimerModal = () => {

    const dispatch = useDispatch()

    const disclaimer = useSelector(state => state?.appInfo?.disclaimer);

    const modals = useSelector(state => state?.modals?.modals)

  const handleClose = () => {
        dispatch(handleModal([{ "DISCLAIMER_MODAL": false }]))
    }


    return (
        <>
            <BzModal size='lg' show={modals['DISCLAIMER_MODAL']} onHide={handleClose} className='modal-breeze-lg'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                <div className='font-medium font-size4 color-text'>Disclaimer</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div data-testid="modal-close" onClick={handleClose} className='icon-16 icon-close icon-dark ms-3'></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-start'>
                            <div className='font-regular font-size2 color-text text-justify'>{disclaimer}</div>
                        </Col>
                    </Row>
                </BzModalBody>
            </BzModal>
        </>
    );
};

export default memo(DisclaimerModal);